import { FEnsembleTypesEnum } from '@spazious/dollhouse-shallow-graph';

import {
  FEnsembleBoardroom,
  FEnsembleBoardroomAttributes,
  FEnsembleBoardroomSchema,
} from './FEnsembleBoardroom.js';
import {
  FEnsembleCabaret,
  FEnsembleCabaretAttributes,
  FEnsembleCabaretSchema,
} from './FEnsembleCabaret.js';
import {
  FEnsembleDesktop,
  FEnsembleDesktopAttributes,
  FEnsembleDesktopSchema,
} from './FEnsembleDesktop.js';
import {
  FEnsembleRound,
  FEnsembleRoundAttributes,
  FEnsembleRoundSchema,
} from './FEnsembleRound.js';

export type FEnsembleAttributes = {
  [FEnsembleTypesEnum.Desktop]: FEnsembleDesktopAttributes;
  [FEnsembleTypesEnum.Round]: FEnsembleRoundAttributes;
  [FEnsembleTypesEnum.Cabaret]: FEnsembleCabaretAttributes;
  [FEnsembleTypesEnum.Boardroom]: FEnsembleBoardroomAttributes;
};

export type FEnsembleSchemas = {
  [FEnsembleTypesEnum.Desktop]: FEnsembleDesktopSchema;
  [FEnsembleTypesEnum.Round]: FEnsembleRoundSchema;
  [FEnsembleTypesEnum.Cabaret]: FEnsembleCabaretSchema;
  [FEnsembleTypesEnum.Boardroom]: FEnsembleBoardroomSchema;
};

export const FEnsembleFactory = <TType extends FEnsembleTypesEnum>(
  type: TType,
  schema: FEnsembleSchemas[TType],
  initialValues?: FEnsembleAttributes[TType]
) => {
  switch (type) {
    case FEnsembleTypesEnum.Desktop:
      return new FEnsembleDesktop(schema as any, initialValues as any);
    case FEnsembleTypesEnum.Round:
      return new FEnsembleRound(schema as any, initialValues as any);
    case FEnsembleTypesEnum.Cabaret:
      return new FEnsembleCabaret(schema as any, initialValues as any);
    case FEnsembleTypesEnum.Boardroom:
      return new FEnsembleBoardroom(schema as any, initialValues as any);
    default:
      throw new Error(`Unknown FEnsemble type: ${type}`);
  }
};
